import { render } from "./TaskRow.vue?vue&type=template&id=ab5b548c"
import script from "./TaskRow.vue?vue&type=script&lang=js"
export * from "./TaskRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__